import superjson from 'superjson'

export function superjsonParse<T> (value: any): T {
  if (!value)
    return value
  return superjson.parse(value as unknown as string) as T
}
